import React, { useEffect, useState } from 'react';
import {
  TextField, Button, Select, MenuItem, InputLabel, FormControl,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Pagination
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import BASE_URL from "../config";

const AddSectionPage = () => {
  const [dropdowns, setDropdowns] = useState({ course: [], year: [], class: [] });
  const [course, setCourse] = useState('');
  const [year, setYear] = useState('');
  const [classId, setClassId] = useState('');
  const [sectionName, setSectionName] = useState('');
  const [sections, setSections] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const adminName = sessionStorage.getItem("adminName");

  /* useEffect(() => {
    axios.get(`${BASE_URL}/api/dropdowns`).then(res => setDropdowns(res.data));
    fetchSections();
  }, []); */
// Load only courses on first render
useEffect(() => {
  axios.get(`${BASE_URL}/api/dropdowns`).then(res => {
    setDropdowns(prev => ({ ...prev, course: res.data.course }));
  });
  fetchSections(); // show inserted sections on load
}, []);

// Load AcademicYear + Classes when course changes
useEffect(() => {
  if (course) {
    axios.get(`${BASE_URL}/api/dropdowns?courseId=${course}`).then(res => {
      setDropdowns(prev => ({
        ...prev,
        year: res.data.year,
        class: res.data.class
      }));
    });
  } else {
    setDropdowns(prev => ({ ...prev, year: [], class: [] }));
  }
}, [course]);

  const fetchSections = () => {
    axios.get(`${BASE_URL}/api/sections`).then(res => setSections(res.data));
  };

  const handleAdd = async () => {
    if (!course || !year || !classId || !sectionName.trim()) {
      return alert('All fields are required');
    }

    const exists = await axios.post(`${BASE_URL}/api/check-section`, { classId, sectionName });
    if (exists.data.exists) {
      return alert(`${sectionName} already assigned to selected class`);
    }

    await axios.post(`${BASE_URL}/api/add-section`, {
      sectionName,
      classId,
      createdBy: adminName,
    });
    resetForm();
    fetchSections();
  };

  const handleUpdate = async () => {
    if (!course || !year || !classId || !sectionName.trim()) {
      return alert('All fields are required');
    }

    await axios.put(`${BASE_URL}/api/update-section/${editingId}`, {
      sectionName,
      classId,
      updatedBy: adminName,
    });
    resetForm();
    fetchSections();
  };

  const resetForm = () => {
    setEditingId(null);
    setSectionName('');
    setClassId('');
    setCourse('');
    setYear('');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this section?')) {
      await axios.delete(`${BASE_URL}/api/delete-section/${id}`);
      fetchSections();
    }
  };

  const rowsPerPage = 30;
  const filtered = sections.filter(s =>
    s.SectionName.toLowerCase().includes(search.toLowerCase())
  );
  const paged = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div style={{ padding: 20 }}>
      <h2>Add Section</h2>
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Course</InputLabel>
          <Select value={course} label="Course" onChange={e => setCourse(e.target.value)}>
            {dropdowns.course.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Academic Year</InputLabel>
          <Select value={year} label="Academic Year" onChange={e => setYear(e.target.value)}>
            {dropdowns.year.map(y => <MenuItem key={y.id} value={y.id}>{y.name}</MenuItem>)}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Class</InputLabel>
          <Select value={classId} label="Class" onChange={e => setClassId(e.target.value)}>
            {dropdowns.class.map(cl => <MenuItem key={cl.id} value={cl.id}>{cl.name}</MenuItem>)}
          </Select>
        </FormControl>

        <TextField
          label="Section Name"
          value={sectionName}
          onChange={e => setSectionName(e.target.value)}
        />

        {editingId ? (
          <Button variant="contained" color="success" onClick={handleUpdate}>Update</Button>
        ) : (
          <Button variant="contained" onClick={handleAdd}>Add</Button>
        )}
      </div>

      <TextField
        label="Search Sections"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginTop: 20, marginBottom: 10 }}
      />

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow style={{ background: '#eee' }}>
              <TableCell>#</TableCell>
              <TableCell>Section Name</TableCell>
              <TableCell>Class</TableCell>
              <TableCell>Course</TableCell>
              <TableCell>Academic Year</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paged.map((row, idx) => (
              <TableRow key={row.SectionID}>
                <TableCell>{(page - 1) * rowsPerPage + idx + 1}</TableCell>
                <TableCell>{row.SectionName}</TableCell>
                <TableCell>{row.ClassName}</TableCell>
                <TableCell>{row.CourseName}</TableCell>
                <TableCell>{row.AcademicYearName}</TableCell>
                <TableCell>
                  <IconButton onClick={() => {
                    setEditingId(row.SectionID);
                    setSectionName(row.SectionName);
                    setCourse(row.CourseID);
                    setYear(row.AcademicYearID);
                    setClassId(row.ClassID);
                  }}>
                    <Edit color="primary" />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(row.SectionID)}><Delete color="error" /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        count={Math.ceil(filtered.length / rowsPerPage)}
        page={page}
        onChange={(_, val) => setPage(val)}
        sx={{ marginTop: 2 }}
      />
    </div>
  );
};

export default AddSectionPage;
